import { Button, Form, Input } from 'antd';
import { useState } from 'react';
import { apiClient, apiErrorMessage } from '../../../utils';
import { Location } from '../../../models';

export function LocationEditPage(props: { location?: Location; onSaved: () => void }) {
  const [loading, setLoading] = useState(false);

  const onFinish = (values: any) => {
    setLoading(true);
    apiClient
      .put(`locations/${props.location?.id}`, values)
      .then(() => {
        props.onSaved();
      })
      .catch((reason: any) => {
        apiErrorMessage(reason);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Form layout="vertical" name="basic" onFinish={onFinish} initialValues={props.location}>
      <Form.Item
        label="Gösterilen isim"
        name="name"
        rules={[
          { required: true, message: 'Zorunlu alan' },
          { max: 200, message: 'En fazla 200 karakter' },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit" loading={loading}>
          Gönder
        </Button>
      </Form.Item>
    </Form>
  );
}
